// extracted by mini-css-extract-plugin
export default {"container":"BasePhoneInput_container__luCn3","input":"BasePhoneInput_input__RioX2","dropdown":"BasePhoneInput_dropdown__+x0pj"};